import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * Fires a GA4 page_view event on every React Router navigation.
 *
 * The gtag.js install in index.html already fires one page_view on
 * the initial hard load via `gtag('config', …)`. We skip that first
 * change here (the initial useEffect run) so the same page_view
 * isn't double-counted, then fire on every subsequent location
 * change.
 */
export default function AnalyticsRouteTracker() {
  const { pathname, search } = useLocation();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
}
